import workspaceQuery from '../../queries/product/StockErrorWorkspaceQuery.graphql';
import fragment from '../../fragments/product/StockErrorFragment.graphql';
import defaultQuery from '../../queries/product/StockErrorDefault.graphql';
import mutationQuery from '../../mutations/product/StockErrorMutation.graphql';
import instanceQuery from '../../queries/product/StockErrorQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const StockError: EntityType = {
  type: 'StockError',
  title: 'WMS Picking Errors',
  workspaceUrl: '/Products/StockControl/StockError/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'STOCK_ERROR',
};

export default StockError;
